import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Unhandled frontend error", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <main className="app-shell">
          <section className="hero fade-in">
            <p className="eyebrow">Frontend Error</p>
            <h1>Something went wrong</h1>
            <p className="subtitle">
              The app hit an unexpected client-side error.
            </p>
            <div className="meta-row">
              <button className="refresh-btn" onClick={this.handleReset}>
                Try again
              </button>
            </div>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
